import type { AudienceSegmentEntry } from '@openx/types/gqlTypes.ts';

export type DealPromptAudienceDealTargetAccount = {
  audienceAccountId: string;
  dealFormAccountUid: string;
  accountName: string;
} | null;

/**
 * When the set includes non-sellable (data partner) segments, the audience must be owned by that partner account.
 * If every non-sellable segment shares one account and it differs from the signed-in user's account, return it
 * so callers can create the audience and deal under that partner.
 */
export function getDealPromptAudienceDealTargetAccount(
  segments: AudienceSegmentEntry[],
  currentUserAccountId?: string
): DealPromptAudienceDealTargetAccount {
  const nonSellable = segments.filter(segment => !segment.sellable);
  if (nonSellable.length === 0) {
    return null;
  }

  const audienceAccountId = String(nonSellable[0].account_id);

  if (currentUserAccountId != null && audienceAccountId === String(currentUserAccountId)) {
    return null;
  }

  const sameAccount = nonSellable.every(segment => String(segment.account_id) === audienceAccountId);

  if (!sameAccount) {
    return null;
  }

  return {
    audienceAccountId,
    dealFormAccountUid: audienceAccountId,
    accountName: nonSellable[0].account_name,
  };
}
